const graphData_en ={
    "cells": [
        {
            "shape": "edge",
            "attrs": {
                "line": {
                    "stroke": "#5F95FF",
                    "strokeWidth": 1,
                    "targetMarker": {
                        "name": "classic",
                        "size": 8,
                        "width": 8,
                        "height": 8
                    }
                },
                "regex": {
                    "type": "join"
                }
            },
            "id": "c0d8475c-086d-4b12-ad69-4e5995f93673",
            "router": {
                "name": "manhattan"
            },
            "zIndex": 0,
            "source": {
                "cell": "e7dc4914-e8b3-455d-bc6b-17b5dddb37d9",
                "port": "42042678-e75c-43c8-9f7a-5556073e4c27"
            },
            "target": {
                "cell": "9546399e-a977-4cc1-bc7f-80cfdad87279",
                "port": "7fb8bc92-eddd-44c9-b939-230877b3d268"
            }
        },
        {
            "shape": "edge",
            "attrs": {
                "line": {
                    "stroke": "#5F95FF",
                    "strokeWidth": 1,
                    "targetMarker": {
                        "name": "classic",
                        "size": 8,
                        "width": 8,
                        "height": 8
                    }
                },
                "regex": {
                    "type": "join"
                }
            },
            "id": "1a6d1bf7-a2ee-4c78-b92a-cfa56d827b38",
            "router": {
                "name": "manhattan"
            },
            "zIndex": 0,
            "source": {
                "cell": "9546399e-a977-4cc1-bc7f-80cfdad87279",
                "port": "010de69a-e25b-406b-9f64-9b4cec5dfece"
            },
            "target": {
                "cell": "024c451a-9752-4a1f-8744-f78cae3528ca",
                "port": "ad86fada-4d2e-4a39-8e7b-00cfe237fb33"
            }
        },
        {
            "shape": "edge",
            "attrs": {
                "line": {
                    "stroke": "#5F95FF",
                    "strokeWidth": 1,
                    "targetMarker": {
                        "name": "classic",
                        "size": 8,
                        "width": 8,
                        "height": 8
                    }
                },
                "regex": {
                    "type": "join"
                }
            },
            "id": "05f8ff60-c3f7-4f99-86c1-553d9c522333",
            "router": {
                "name": "manhattan"
            },
            "zIndex": 0,
            "source": {
                "cell": "4af288ea-8ec4-48c0-95be-e5756ddd6798",
                "port": "010de69a-e25b-406b-9f64-9b4cec5dfece"
            },
            "target": {
                "cell": "52af7d9d-9047-4539-8a8d-67403be64088",
                "port": "b750f039-dac5-4ca8-8ce1-f99e64224912"
            }
        },
        {
            "shape": "edge",
            "attrs": {
                "line": {
                    "stroke": "#5F95FF",
                    "strokeWidth": 1,
                    "targetMarker": {
                        "name": "classic",
                        "size": 8,
                        "width": 8,
                        "height": 8
                    }
                },
                "regex": {
                    "type": "join"
                }
            },
            "id": "87885ce1-028f-4569-913d-3a4800314c94",
            "router": {
                "name": "manhattan"
            },
            "zIndex": 0,
            "source": {
                "cell": "024c451a-9752-4a1f-8744-f78cae3528ca",
                "port": "16180c3c-c492-4c73-b48d-27cb125fa49d"
            },
            "target": {
                "cell": "4af288ea-8ec4-48c0-95be-e5756ddd6798",
                "port": "7fb8bc92-eddd-44c9-b939-230877b3d268"
            }
        },
        {
            "shape": "edge",
            "attrs": {
                "line": {
                    "stroke": "#5F95FF",
                    "strokeWidth": 1,
                    "targetMarker": {
                        "name": "classic",
                        "size": 8,
                        "width": 8,
                        "height": 8
                    }
                },
                "regex": {
                    "type": "join"
                }
            },
            "id": "b041ac37-8d06-467b-89fc-c8ce29a28609",
            "router": {
                "name": "manhattan"
            },
            "zIndex": 0,
            "source": {
                "cell": "1f9cee52-fa0d-44c0-9563-31f0f7f3e017",
                "port": "0e55dd34-38b3-4d8a-919a-35f83042a8db"
            },
            "target": {
                "cell": "a3de8273-8160-459d-8b41-5b4efb757638",
                "port": "b9418203-5036-4d51-a79c-d50e67278aba"
            }
        },
        {
            "shape": "edge",
            "attrs": {
                "line": {
                    "stroke": "#5F95FF",
                    "strokeWidth": 1,
                    "targetMarker": {
                        "name": "classic",
                        "size": 8,
                        "width": 8,
                        "height": 8
                    }
                },
                "regex": {
                    "type": "join"
                }
            },
            "id": "332a7bc1-1756-4b97-89bb-5ef14f93060a",
            "router": {
                "name": "manhattan"
            },
            "zIndex": 0,
            "source": {
                "cell": "1e724a45-c643-4657-911f-a6d2f9283cd9",
                "port": "6bb0edd1-f12e-4dae-9c12-1b2da9ad7ff6"
            },
            "target": {
                "cell": "1f9cee52-fa0d-44c0-9563-31f0f7f3e017",
                "port": "14b5f98f-3c04-42db-85ca-9eba42e66bb0"
            }
        },
        {
            "shape": "edge",
            "attrs": {
                "line": {
                    "stroke": "#5F95FF",
                    "strokeWidth": 1,
                    "targetMarker": {
                        "name": "classic",
                        "size": 8,
                        "width": 8,
                        "height": 8
                    }
                },
                "regex": {
                    "type": "join"
                }
            },
            "id": "612b0c7c-0106-471a-84c8-09a771b9d6ef",
            "router": {
                "name": "manhattan"
            },
            "zIndex": 0,
            "source": {
                "cell": "b8704953-ef4a-43bc-94a5-ffc8c613bf3e",
                "port": "c54272aa-e1d3-4fa6-998a-66d730a1ef3e"
            },
            "target": {
                "cell": "1e724a45-c643-4657-911f-a6d2f9283cd9",
                "port": "099c7927-137f-4069-80bb-c617d69a4335"
            }
        },
        {
            "shape": "edge",
            "attrs": {
                "line": {
                    "stroke": "#5F95FF",
                    "strokeWidth": 1,
                    "targetMarker": {
                        "name": "classic",
                        "size": 8,
                        "width": 8,
                        "height": 8
                    }
                },
                "regex": {
                    "type": "join"
                }
            },
            "id": "1f60eeb3-bf17-4f17-b369-0aff6b79df9f",
            "router": {
                "name": "manhattan"
            },
            "zIndex": 0,
            "source": {
                "cell": "c6291fb9-cf11-4599-a915-e7bc455af13c",
                "port": "332e43b0-b494-430e-a0ae-9b0bba02a7f7"
            },
            "target": {
                "cell": "b8704953-ef4a-43bc-94a5-ffc8c613bf3e",
                "port": "3171ac62-5f5c-4d9c-9e98-b4f6b3d14e14"
            }
        },
        {
            "position": {
                "x": 110,
                "y": 140
            },
            "size": {
                "width": 70,
                "height": 32
            },
            "attrs": {
                "text": {
                    "textWrap": {
                        "text": "Begin with",
                        "text_hint": "Fixed Element"
                    }
                },
                "regex": {
                    "type": "Caret"
                },
                "title": {
                    "text": "Caret",
                    "text_hint": "                          The regex ^.                          Usage:                              pattern = Pattern(Caret(), 'bar')                              print(pattern.mkregex())                          Output:                              ^bar                          "
                }
            },
            "shape": "flow-chart-rect",
            "ports": {
                "groups": {
                    "top": {
                        "position": "top",
                        "attrs": {
                            "circle": {
                                "r": 3,
                                "magnet": true,
                                "stroke": "#5F95FF",
                                "strokeWidth": 1,
                                "fill": "#fff",
                                "style": {
                                    "visibility": "hidden"
                                }
                            }
                        }
                    },
                    "right": {
                        "position": "right",
                        "attrs": {
                            "circle": {
                                "r": 3,
                                "magnet": true,
                                "stroke": "#5F95FF",
                                "strokeWidth": 1,
                                "fill": "#fff",
                                "style": {
                                    "visibility": "hidden"
                                }
                            }
                        }
                    },
                    "bottom": {
                        "position": "bottom",
                        "attrs": {
                            "circle": {
                                "r": 3,
                                "magnet": true,
                                "stroke": "#5F95FF",
                                "strokeWidth": 1,
                                "fill": "#fff",
                                "style": {
                                    "visibility": "hidden"
                                }
                            }
                        }
                    },
                    "left": {
                        "position": "left",
                        "attrs": {
                            "circle": {
                                "r": 3,
                                "magnet": true,
                                "stroke": "#5F95FF",
                                "strokeWidth": 1,
                                "fill": "#fff",
                                "style": {
                                    "visibility": "hidden"
                                }
                            }
                        }
                    }
                },
                "items": [
                    {
                        "group": "top",
                        "id": "72c2dacc-3aa0-451e-bc86-04a576060925"
                    },
                    {
                        "group": "right",
                        "id": "42042678-e75c-43c8-9f7a-5556073e4c27"
                    },
                    {
                        "group": "bottom",
                        "id": "5ebc0254-58bb-4446-b938-dff47c35472c"
                    },
                    {
                        "group": "left",
                        "id": "19860cd1-45a7-4c07-bc6a-3efa73ca555f"
                    }
                ]
            },
            "id": "e7dc4914-e8b3-455d-bc6b-17b5dddb37d9",
            "zIndex": 1
        },
        {
            "position": {
                "x": 302,
                "y": 122
            },
            "size": {
                "width": 100,
                "height": 68
            },
            "attrs": {
                "text": {
                    "text": "regex",
                    "text_hint": "String"
                },
                "regex": {
                    "type": "String_Group"
                },
                "title": {
                    "text": "String_Group",
                    "text_hint": "Combine String with Group"
                }
            },
            "shape": "flow-chart-title-rect",
            "ports": {
                "groups": {
                    "top": {
                        "position": "top",
                        "attrs": {
                            "circle": {
                                "r": 3,
                                "magnet": true,
                                "stroke": "#5F95FF",
                                "strokeWidth": 1,
                                "fill": "#fff",
                                "style": {
                                    "visibility": "hidden"
                                }
                            }
                        }
                    },
                    "right": {
                        "position": "right",
                        "attrs": {
                            "circle": {
                                "r": 3,
                                "magnet": true,
                                "stroke": "#5F95FF",
                                "strokeWidth": 1,
                                "fill": "#fff",
                                "style": {
                                    "visibility": "hidden"
                                }
                            }
                        }
                    },
                    "bottom": {
                        "position": "bottom",
                        "attrs": {
                            "circle": {
                                "r": 3,
                                "magnet": true,
                                "stroke": "#5F95FF",
                                "strokeWidth": 1,
                                "fill": "#fff",
                                "style": {
                                    "visibility": "hidden"
                                }
                            }
                        }
                    },
                    "left": {
                        "position": "left",
                        "attrs": {
                            "circle": {
                                "r": 3,
                                "magnet": true,
                                "stroke": "#5F95FF",
                                "strokeWidth": 1,
                                "fill": "#fff",
                                "style": {
                                    "visibility": "hidden"
                                }
                            }
                        }
                    }
                },
                "items": [
                    {
                        "group": "top",
                        "id": "a55c68a2-f91e-446e-b13a-cd8941ab2941"
                    },
                    {
                        "group": "right",
                        "id": "010de69a-e25b-406b-9f64-9b4cec5dfece"
                    },
                    {
                        "group": "bottom",
                        "id": "4aee4040-538e-4c27-81a5-1f18fa5e4157"
                    },
                    {
                        "group": "left",
                        "id": "7fb8bc92-eddd-44c9-b939-230877b3d268"
                    }
                ]
            },
            "id": "9546399e-a977-4cc1-bc7f-80cfdad87279",
            "zIndex": 2
        },
        {
            "position": {
                "x": 494,
                "y": 91
            },
            "size": {
                "width": 160,
                "height": 130
            },
            "attrs": {
                "text": {
                    "text": "",
                    "text_hint": "String"
                },
                "regex": {
                    "type": "OneOrMore"
                },
                "title": {
                    "text": "OneOrMore",
                    "text_hint": "The regex op *. It works alike Repeat."
                }
            },
            "shape": "flow-chart-title-rect",
            "ports": {
                "groups": {
                    "top": {
                        "position": "top",
                        "attrs": {
                            "circle": {
                                "r": 3,
                                "magnet": true,
                                "stroke": "#5F95FF",
                                "strokeWidth": 1,
                                "fill": "#fff",
                                "style": {
                                    "visibility": "hidden"
                                }
                            }
                        }
                    },
                    "right": {
                        "position": "right",
                        "attrs": {
                            "circle": {
                                "r": 3,
                                "magnet": true,
                                "stroke": "#5F95FF",
                                "strokeWidth": 1,
                                "fill": "#fff",
                                "style": {
                                    "visibility": "hidden"
                                }
                            }
                        }
                    },
                    "bottom": {
                        "position": "bottom",
                        "attrs": {
                            "circle": {
                                "r": 3,
                                "magnet": true,
                                "stroke": "#5F95FF",
                                "strokeWidth": 1,
                                "fill": "#fff",
                                "style": {
                                    "visibility": "hidden"
                                }
                            }
                        }
                    },
                    "left": {
                        "position": "left",
                        "attrs": {
                            "circle": {
                                "r": 3,
                                "magnet": true,
                                "stroke": "#5F95FF",
                                "strokeWidth": 1,
                                "fill": "#fff",
                                "style": {
                                    "visibility": "hidden"
                                }
                            }
                        }
                    }
                },
                "items": [
                    {
                        "group": "top",
                        "id": "0cc7dec6-bb43-44a0-be2a-13b4bfd5504c"
                    },
                    {
                        "group": "right",
                        "id": "16180c3c-c492-4c73-b48d-27cb125fa49d"
                    },
                    {
                        "group": "bottom",
                        "id": "8b38b349-f2b0-43a4-ac26-6dfac7fc28ce"
                    },
                    {
                        "group": "left",
                        "id": "ad86fada-4d2e-4a39-8e7b-00cfe237fb33"
                    }
                ]
            },
            "id": "024c451a-9752-4a1f-8744-f78cae3528ca",
            "data": {
                "parent": true
            },
            "zIndex": 3,
            "children": [
                "3b15f409-4c4c-4363-b16d-2549c3eb450a"
            ]
        },
        {
            "position": {
                "x": 539,
                "y": 144.99999999999994
            },
            "size": {
                "width": 70,
                "height": 32
            },
            "attrs": {
                "text": {
                    "textWrap": {
                        "text": "Any Character",
                        "text_hint": "Fixed Element"
                    }
                },
                "body": {
                    "stroke": "#73d13d"
                },
                "regex": {
                    "type": "X"
                },
                "title": {
                    "text": "X",
                    "text_hint": "The dot.                          ."
                }
            },
            "shape": "flow-chart-rect",
            "ports": {
                "groups": {
                    "top": {
                        "position": "top",
                        "attrs": {
                            "circle": {
                                "r": 3,
                                "magnet": true,
                                "stroke": "#5F95FF",
                                "strokeWidth": 1,
                                "fill": "#fff",
                                "style": {
                                    "visibility": "hidden"
                                }
                            }
                        }
                    },
                    "right": {
                        "position": "right",
                        "attrs": {
                            "circle": {
                                "r": 3,
                                "magnet": true,
                                "stroke": "#5F95FF",
                                "strokeWidth": 1,
                                "fill": "#fff",
                                "style": {
                                    "visibility": "hidden"
                                }
                            }
                        }
                    },
                    "bottom": {
                        "position": "bottom",
                        "attrs": {
                            "circle": {
                                "r": 3,
                                "magnet": true,
                                "stroke": "#5F95FF",
                                "strokeWidth": 1,
                                "fill": "#fff",
                                "style": {
                                    "visibility": "hidden"
                                }
                            }
                        }
                    },
                    "left": {
                        "position": "left",
                        "attrs": {
                            "circle": {
                                "r": 3,
                                "magnet": true,
                                "stroke": "#5F95FF",
                                "strokeWidth": 1,
                                "fill": "#fff",
                                "style": {
                                    "visibility": "hidden"
                                }
                            }
                        }
                    }
                },
                "items": [
                    {
                        "group": "top",
                        "id": "36c3e97f-76d2-4bd8-a6ec-d7780a638260"
                    },
                    {
                        "group": "right",
                        "id": "b76a823f-3cfc-408e-97aa-5b3ce5d0ad3a"
                    },
                    {
                        "group": "bottom",
                        "id": "55ae8141-41ba-484d-a0e1-d2527c58c238"
                    },
                    {
                        "group": "left",
                        "id": "51ef94c3-5ad9-4f33-82a6-9f687a46a274"
                    }
                ]
            },
            "id": "3b15f409-4c4c-4363-b16d-2549c3eb450a",
            "zIndex": 4,
            "parent": "024c451a-9752-4a1f-8744-f78cae3528ca"
        },
        {
            "position": {
                "x": 871,
                "y": 140
            },
            "size": {
                "width": 70,
                "height": 32
            },
            "attrs": {
                "text": {
                    "textWrap": {
                        "text": "to End",
                        "text_hint": "Fixed Element"
                    }
                },
                "regex": {
                    "type": "Dollar"
                },
                "title": {
                    "text": "Dollar",
                    "text_hint": "                          The regex $.                          Usage:                              pattern = Pattern('foobar', Dollar())                              print(pattern.mkregex())                          Output:                              foobar$                          "
                }
            },
            "shape": "flow-chart-rect",
            "ports": {
                "groups": {
                    "top": {
                        "position": "top",
                        "attrs": {
                            "circle": {
                                "r": 3,
                                "magnet": true,
                                "stroke": "#5F95FF",
                                "strokeWidth": 1,
                                "fill": "#fff",
                                "style": {
                                    "visibility": "hidden"
                                }
                            }
                        }
                    },
                    "right": {
                        "position": "right",
                        "attrs": {
                            "circle": {
                                "r": 3,
                                "magnet": true,
                                "stroke": "#5F95FF",
                                "strokeWidth": 1,
                                "fill": "#fff",
                                "style": {
                                    "visibility": "hidden"
                                }
                            }
                        }
                    },
                    "bottom": {
                        "position": "bottom",
                        "attrs": {
                            "circle": {
                                "r": 3,
                                "magnet": true,
                                "stroke": "#5F95FF",
                                "strokeWidth": 1,
                                "fill": "#fff",
                                "style": {
                                    "visibility": "hidden"
                                }
                            }
                        }
                    },
                    "left": {
                        "position": "left",
                        "attrs": {
                            "circle": {
                                "r": 3,
                                "magnet": true,
                                "stroke": "#5F95FF",
                                "strokeWidth": 1,
                                "fill": "#fff",
                                "style": {
                                    "visibility": "hidden"
                                }
                            }
                        }
                    }
                },
                "items": [
                    {
                        "group": "top",
                        "id": "b827816b-0c8e-49ea-a6bc-0cd2a64da4dd"
                    },
                    {
                        "group": "right",
                        "id": "f432db1d-1649-42cb-84b2-c9f4e0474729"
                    },
                    {
                        "group": "bottom",
                        "id": "fcbb8611-292a-4ad2-9c60-f691b2ae0a03"
                    },
                    {
                        "group": "left",
                        "id": "b750f039-dac5-4ca8-8ce1-f99e64224912"
                    }
                ]
            },
            "id": "52af7d9d-9047-4539-8a8d-67403be64088",
            "zIndex": 5
        },
        {
            "position": {
                "x": 700,
                "y": 122
            },
            "size": {
                "width": 100,
                "height": 68
            },
            "attrs": {
                "text": {
                    "text": "olllo.top",
                    "text_hint": "String"
                },
                "regex": {
                    "type": "String_Group"
                },
                "title": {
                    "text": "String_Group",
                    "text_hint": "Combine String with Group"
                }
            },
            "shape": "flow-chart-title-rect",
            "ports": {
                "groups": {
                    "top": {
                        "position": "top",
                        "attrs": {
                            "circle": {
                                "r": 3,
                                "magnet": true,
                                "stroke": "#5F95FF",
                                "strokeWidth": 1,
                                "fill": "#fff",
                                "style": {
                                    "visibility": "hidden"
                                }
                            }
                        }
                    },
                    "right": {
                        "position": "right",
                        "attrs": {
                            "circle": {
                                "r": 3,
                                "magnet": true,
                                "stroke": "#5F95FF",
                                "strokeWidth": 1,
                                "fill": "#fff",
                                "style": {
                                    "visibility": "hidden"
                                }
                            }
                        }
                    },
                    "bottom": {
                        "position": "bottom",
                        "attrs": {
                            "circle": {
                                "r": 3,
                                "magnet": true,
                                "stroke": "#5F95FF",
                                "strokeWidth": 1,
                                "fill": "#fff",
                                "style": {
                                    "visibility": "hidden"
                                }
                            }
                        }
                    },
                    "left": {
                        "position": "left",
                        "attrs": {
                            "circle": {
                                "r": 3,
                                "magnet": true,
                                "stroke": "#5F95FF",
                                "strokeWidth": 1,
                                "fill": "#fff",
                                "style": {
                                    "visibility": "hidden"
                                }
                            }
                        }
                    }
                },
                "items": [
                    {
                        "group": "top",
                        "id": "a55c68a2-f91e-446e-b13a-cd8941ab2941"
                    },
                    {
                        "group": "right",
                        "id": "010de69a-e25b-406b-9f64-9b4cec5dfece"
                    },
                    {
                        "group": "bottom",
                        "id": "4aee4040-538e-4c27-81a5-1f18fa5e4157"
                    },
                    {
                        "group": "left",
                        "id": "7fb8bc92-eddd-44c9-b939-230877b3d268"
                    }
                ]
            },
            "id": "4af288ea-8ec4-48c0-95be-e5756ddd6798",
            "zIndex": 6
        },
        {
            "position": {
                "x": 110,
                "y": 318
            },
            "size": {
                "width": 70,
                "height": 32
            },
            "attrs": {
                "text": {
                    "textWrap": {
                        "text": "Begin with",
                        "text_hint": "Fixed Element"
                    }
                },
                "regex": {
                    "type": "Caret"
                },
                "title": {
                    "text": "Caret",
                    "text_hint": "                          The regex ^.                          Usage:                              pattern = Pattern(Caret(), 'bar')                              print(pattern.mkregex())                          Output:                              ^bar                          "
                }
            },
            "shape": "flow-chart-rect",
            "ports": {
                "groups": {
                    "top": {
                        "position": "top",
                        "attrs": {
                            "circle": {
                                "r": 3,
                                "magnet": true,
                                "stroke": "#5F95FF",
                                "strokeWidth": 1,
                                "fill": "#fff",
                                "style": {
                                    "visibility": "hidden"
                                }
                            }
                        }
                    },
                    "right": {
                        "position": "right",
                        "attrs": {
                            "circle": {
                                "r": 3,
                                "magnet": true,
                                "stroke": "#5F95FF",
                                "strokeWidth": 1,
                                "fill": "#fff",
                                "style": {
                                    "visibility": "hidden"
                                }
                            }
                        }
                    },
                    "bottom": {
                        "position": "bottom",
                        "attrs": {
                            "circle": {
                                "r": 3,
                                "magnet": true,
                                "stroke": "#5F95FF",
                                "strokeWidth": 1,
                                "fill": "#fff",
                                "style": {
                                    "visibility": "hidden"
                                }
                            }
                        }
                    },
                    "left": {
                        "position": "left",
                        "attrs": {
                            "circle": {
                                "r": 3,
                                "magnet": true,
                                "stroke": "#5F95FF",
                                "strokeWidth": 1,
                                "fill": "#fff",
                                "style": {
                                    "visibility": "hidden"
                                }
                            }
                        }
                    }
                },
                "items": [
                    {
                        "group": "top",
                        "id": "5d2fb963-8275-4b57-9acd-3caa942a4ca3"
                    },
                    {
                        "group": "right",
                        "id": "332e43b0-b494-430e-a0ae-9b0bba02a7f7"
                    },
                    {
                        "group": "bottom",
                        "id": "8119b411-8364-4ec6-9680-82811bf28168"
                    },
                    {
                        "group": "left",
                        "id": "f6364cb4-780e-4f3f-9f76-61ba9a6c7813"
                    }
                ]
            },
            "id": "c6291fb9-cf11-4599-a915-e7bc455af13c",
            "zIndex": 7
        },
        {
            "position": {
                "x": 267,
                "y": 264
            },
            "size": {
                "width": 170,
                "height": 140
            },
            "attrs": {
                "text": {
                    "text": "",
                    "text_hint": "Multiple Characters"
                },
                "regex": {
                    "type": "Include"
                },
                "title": {
                    "text": "Include",
                    "text_hint": "Sets.                         [abc]"
                }
            },
            "shape": "flow-chart-title-rect",
            "ports": {
                "groups": {
                    "top": {
                        "position": "top",
                        "attrs": {
                            "circle": {
                                "r": 3,
                                "magnet": true,
                                "stroke": "#5F95FF",
                                "strokeWidth": 1,
                                "fill": "#fff",
                                "style": {
                                    "visibility": "hidden"
                                }
                            }
                        }
                    },
                    "right": {
                        "position": "right",
                        "attrs": {
                            "circle": {
                                "r": 3,
                                "magnet": true,
                                "stroke": "#5F95FF",
                                "strokeWidth": 1,
                                "fill": "#fff",
                                "style": {
                                    "visibility": "hidden"
                                }
                            }
                        }
                    },
                    "bottom": {
                        "position": "bottom",
                        "attrs": {
                            "circle": {
                                "r": 3,
                                "magnet": true,
                                "stroke": "#5F95FF",
                                "strokeWidth": 1,
                                "fill": "#fff",
                                "style": {
                                    "visibility": "hidden"
                                }
                            }
                        }
                    },
                    "left": {
                        "position": "left",
                        "attrs": {
                            "circle": {
                                "r": 3,
                                "magnet": true,
                                "stroke": "#5F95FF",
                                "strokeWidth": 1,
                                "fill": "#fff",
                                "style": {
                                    "visibility": "hidden"
                                }
                            }
                        }
                    }
                },
                "items": [
                    {
                        "group": "top",
                        "id": "dc00937a-540c-4cf2-901e-4af5d56770f1"
                    },
                    {
                        "group": "right",
                        "id": "c54272aa-e1d3-4fa6-998a-66d730a1ef3e"
                    },
                    {
                        "group": "bottom",
                        "id": "8f8c81a8-062d-4105-ae7f-1b473a1b83d1"
                    },
                    {
                        "group": "left",
                        "id": "3171ac62-5f5c-4d9c-9e98-b4f6b3d14e14"
                    }
                ]
            },
            "id": "b8704953-ef4a-43bc-94a5-ffc8c613bf3e",
            "data": {
                "parent": true
            },
            "zIndex": 8,
            "children": [
                "2a727aec-7263-4c3a-87de-f36d13c35820"
            ]
        },
        {
            "position": {
                "x": 302,
                "y": 300
            },
            "size": {
                "width": 100,
                "height": 68
            },
            "attrs": {
                "text": {
                    "text": "",
                    "text_hint": ""
                },
                "body": {
                    "stroke": "#73d13d"
                },
                "regex": {
                    "type": "Seq"
                },
                "title": {
                    "text": "Seq",
                    "text_hint": "Map to a sequence like a-z, A-Z, 0-9 etc.                          It can only be used with Include or Exclude."
                },
                "params": {
                    "hint1": "start",
                    "hint2": "end",
                    "start": "a",
                    "end": "z"
                }
            },
            "shape": "flow-chart-title-param-rect",
            "ports": {
                "groups": {
                    "top": {
                        "position": "top",
                        "attrs": {
                            "circle": {
                                "r": 3,
                                "magnet": true,
                                "stroke": "#5F95FF",
                                "strokeWidth": 1,
                                "fill": "#fff",
                                "style": {
                                    "visibility": "hidden"
                                }
                            }
                        }
                    },
                    "right": {
                        "position": "right",
                        "attrs": {
                            "circle": {
                                "r": 3,
                                "magnet": true,
                                "stroke": "#5F95FF",
                                "strokeWidth": 1,
                                "fill": "#fff",
                                "style": {
                                    "visibility": "hidden"
                                }
                            }
                        }
                    },
                    "bottom": {
                        "position": "bottom",
                        "attrs": {
                            "circle": {
                                "r": 3,
                                "magnet": true,
                                "stroke": "#5F95FF",
                                "strokeWidth": 1,
                                "fill": "#fff",
                                "style": {
                                    "visibility": "hidden"
                                }
                            }
                        }
                    },
                    "left": {
                        "position": "left",
                        "attrs": {
                            "circle": {
                                "r": 3,
                                "magnet": true,
                                "stroke": "#5F95FF",
                                "strokeWidth": 1,
                                "fill": "#fff",
                                "style": {
                                    "visibility": "hidden"
                                }
                            }
                        }
                    }
                },
                "items": [
                    {
                        "group": "top",
                        "id": "db52df19-0219-4c0e-a8c3-3090129f9ddc"
                    },
                    {
                        "group": "right",
                        "id": "515adfbe-0a16-44a5-a476-d53851fdace3"
                    },
                    {
                        "group": "bottom",
                        "id": "ad546be8-6e13-41a4-8874-68ab17abaf5d"
                    },
                    {
                        "group": "left",
                        "id": "d48356f4-e69d-43d2-8085-507267bad185"
                    }
                ]
            },
            "id": "2a727aec-7263-4c3a-87de-f36d13c35820",
            "zIndex": 9,
            "parent": "b8704953-ef4a-43bc-94a5-ffc8c613bf3e"
        },
        {
            "position": {
                "x": 539,
                "y": 269
            },
            "size": {
                "width": 160,
                "height": 130
            },
            "attrs": {
                "text": {
                    "text": "olllo.top",
                    "text_hint": "String"
                },
                "regex": {
                    "type": "Repeat"
                },
                "title": {
                    "text": "Repeat",
                    "text_hint": "                          The regex a{min, max)}                          Usage:                              repeat = Repeat('a', 1)                              print(repeat)                          Output:                              a{1,}                          "
                },
                "params": {
                    "hint1": "Min",
                    "hint2": "Max",
                    "min": "1",
                    "max": "8"
                }
            },
            "shape": "flow-chart-title-param-rect",
            "ports": {
                "groups": {
                    "top": {
                        "position": "top",
                        "attrs": {
                            "circle": {
                                "r": 3,
                                "magnet": true,
                                "stroke": "#5F95FF",
                                "strokeWidth": 1,
                                "fill": "#fff",
                                "style": {
                                    "visibility": "hidden"
                                }
                            }
                        }
                    },
                    "right": {
                        "position": "right",
                        "attrs": {
                            "circle": {
                                "r": 3,
                                "magnet": true,
                                "stroke": "#5F95FF",
                                "strokeWidth": 1,
                                "fill": "#fff",
                                "style": {
                                    "visibility": "hidden"
                                }
                            }
                        }
                    },
                    "bottom": {
                        "position": "bottom",
                        "attrs": {
                            "circle": {
                                "r": 3,
                                "magnet": true,
                                "stroke": "#5F95FF",
                                "strokeWidth": 1,
                                "fill": "#fff",
                                "style": {
                                    "visibility": "hidden"
                                }
                            }
                        }
                    },
                    "left": {
                        "position": "left",
                        "attrs": {
                            "circle": {
                                "r": 3,
                                "magnet": true,
                                "stroke": "#5F95FF",
                                "strokeWidth": 1,
                                "fill": "#fff",
                                "style": {
                                    "visibility": "hidden"
                                }
                            }
                        }
                    }
                },
                "items": [
                    {
                        "group": "top",
                        "id": "9740046a-cd83-4686-ba19-fd749c0787c8"
                    },
                    {
                        "group": "right",
                        "id": "6bb0edd1-f12e-4dae-9c12-1b2da9ad7ff6"
                    },
                    {
                        "group": "bottom",
                        "id": "53b68c13-4141-48ac-90db-25f8709611a2"
                    },
                    {
                        "group": "left",
                        "id": "099c7927-137f-4069-80bb-c617d69a4335"
                    }
                ]
            },
            "id": "1e724a45-c643-4657-911f-a6d2f9283cd9",
            "data": {
                "parent": true
            },
            "zIndex": 10
        },
        {
            "position": {
                "x": 750,
                "y": 269
            },
            "size": {
                "width": 160,
                "height": 130
            },
            "attrs": {
                "text": {
                    "text": "",
                    "text_hint": "Multiple Characters"
                },
                "regex": {
                    "type": "Exclude"
                },
                "title": {
                    "text": "Exclude",
                    "text_hint": "Excluding.                          [^abc]"
                }
            },
            "shape": "flow-chart-title-rect",
            "ports": {
                "groups": {
                    "top": {
                        "position": "top",
                        "attrs": {
                            "circle": {
                                "r": 3,
                                "magnet": true,
                                "stroke": "#5F95FF",
                                "strokeWidth": 1,
                                "fill": "#fff",
                                "style": {
                                    "visibility": "hidden"
                                }
                            }
                        }
                    },
                    "right": {
                        "position": "right",
                        "attrs": {
                            "circle": {
                                "r": 3,
                                "magnet": true,
                                "stroke": "#5F95FF",
                                "strokeWidth": 1,
                                "fill": "#fff",
                                "style": {
                                    "visibility": "hidden"
                                }
                            }
                        }
                    },
                    "bottom": {
                        "position": "bottom",
                        "attrs": {
                            "circle": {
                                "r": 3,
                                "magnet": true,
                                "stroke": "#5F95FF",
                                "strokeWidth": 1,
                                "fill": "#fff",
                                "style": {
                                    "visibility": "hidden"
                                }
                            }
                        }
                    },
                    "left": {
                        "position": "left",
                        "attrs": {
                            "circle": {
                                "r": 3,
                                "magnet": true,
                                "stroke": "#5F95FF",
                                "strokeWidth": 1,
                                "fill": "#fff",
                                "style": {
                                    "visibility": "hidden"
                                }
                            }
                        }
                    }
                },
                "items": [
                    {
                        "group": "top",
                        "id": "e33cf320-a8ca-4f71-9923-a71320f28b04"
                    },
                    {
                        "group": "right",
                        "id": "0e55dd34-38b3-4d8a-919a-35f83042a8db"
                    },
                    {
                        "group": "bottom",
                        "id": "3e7e9537-b9cd-4d62-8d4a-678127ca7d8c"
                    },
                    {
                        "group": "left",
                        "id": "14b5f98f-3c04-42db-85ca-9eba42e66bb0"
                    }
                ]
            },
            "id": "1f9cee52-fa0d-44c0-9563-31f0f7f3e017",
            "data": {
                "parent": true
            },
            "zIndex": 11,
            "children": [
                "642b3816-5774-48b2-bf11-fee19172eefb"
            ]
        },
        {
            "position": {
                "x": 780,
                "y": 304.99999999999994
            },
            "size": {
                "width": 100,
                "height": 68
            },
            "attrs": {
                "text": {
                    "text": "",
                    "text_hint": ""
                },
                "body": {
                    "stroke": "#73d13d"
                },
                "regex": {
                    "type": "Seq"
                },
                "title": {
                    "text": "Seq",
                    "text_hint": "Map to a sequence like a-z, A-Z, 0-9 etc.                          It can only be used with Include or Exclude."
                },
                "params": {
                    "hint1": "start",
                    "hint2": "end",
                    "start": "6",
                    "end": "8"
                }
            },
            "shape": "flow-chart-title-param-rect",
            "ports": {
                "groups": {
                    "top": {
                        "position": "top",
                        "attrs": {
                            "circle": {
                                "r": 3,
                                "magnet": true,
                                "stroke": "#5F95FF",
                                "strokeWidth": 1,
                                "fill": "#fff",
                                "style": {
                                    "visibility": "hidden"
                                }
                            }
                        }
                    },
                    "right": {
                        "position": "right",
                        "attrs": {
                            "circle": {
                                "r": 3,
                                "magnet": true,
                                "stroke": "#5F95FF",
                                "strokeWidth": 1,
                                "fill": "#fff",
                                "style": {
                                    "visibility": "hidden"
                                }
                            }
                        }
                    },
                    "bottom": {
                        "position": "bottom",
                        "attrs": {
                            "circle": {
                                "r": 3,
                                "magnet": true,
                                "stroke": "#5F95FF",
                                "strokeWidth": 1,
                                "fill": "#fff",
                                "style": {
                                    "visibility": "hidden"
                                }
                            }
                        }
                    },
                    "left": {
                        "position": "left",
                        "attrs": {
                            "circle": {
                                "r": 3,
                                "magnet": true,
                                "stroke": "#5F95FF",
                                "strokeWidth": 1,
                                "fill": "#fff",
                                "style": {
                                    "visibility": "hidden"
                                }
                            }
                        }
                    }
                },
                "items": [
                    {
                        "group": "top",
                        "id": "db52df19-0219-4c0e-a8c3-3090129f9ddc"
                    },
                    {
                        "group": "right",
                        "id": "515adfbe-0a16-44a5-a476-d53851fdace3"
                    },
                    {
                        "group": "bottom",
                        "id": "ad546be8-6e13-41a4-8874-68ab17abaf5d"
                    },
                    {
                        "group": "left",
                        "id": "d48356f4-e69d-43d2-8085-507267bad185"
                    }
                ]
            },
            "id": "642b3816-5774-48b2-bf11-fee19172eefb",
            "zIndex": 12,
            "parent": "1f9cee52-fa0d-44c0-9563-31f0f7f3e017"
        },
        {
            "position": {
                "x": 980,
                "y": 318
            },
            "size": {
                "width": 70,
                "height": 32
            },
            "attrs": {
                "text": {
                    "textWrap": {
                        "text": "to End",
                        "text_hint": "Fixed Element"
                    }
                },
                "regex": {
                    "type": "Dollar"
                },
                "title": {
                    "text": "Dollar",
                    "text_hint": "                          The regex $.                          Usage:                              pattern = Pattern('foobar', Dollar())                              print(pattern.mkregex())                          Output:                              foobar$                          "
                }
            },
            "shape": "flow-chart-rect",
            "ports": {
                "groups": {
                    "top": {
                        "position": "top",
                        "attrs": {
                            "circle": {
                                "r": 3,
                                "magnet": true,
                                "stroke": "#5F95FF",
                                "strokeWidth": 1,
                                "fill": "#fff",
                                "style": {
                                    "visibility": "hidden"
                                }
                            }
                        }
                    },
                    "right": {
                        "position": "right",
                        "attrs": {
                            "circle": {
                                "r": 3,
                                "magnet": true,
                                "stroke": "#5F95FF",
                                "strokeWidth": 1,
                                "fill": "#fff",
                                "style": {
                                    "visibility": "hidden"
                                }
                            }
                        }
                    },
                    "bottom": {
                        "position": "bottom",
                        "attrs": {
                            "circle": {
                                "r": 3,
                                "magnet": true,
                                "stroke": "#5F95FF",
                                "strokeWidth": 1,
                                "fill": "#fff",
                                "style": {
                                    "visibility": "hidden"
                                }
                            }
                        }
                    },
                    "left": {
                        "position": "left",
                        "attrs": {
                            "circle": {
                                "r": 3,
                                "magnet": true,
                                "stroke": "#5F95FF",
                                "strokeWidth": 1,
                                "fill": "#fff",
                                "style": {
                                    "visibility": "hidden"
                                }
                            }
                        }
                    }
                },
                "items": [
                    {
                        "group": "top",
                        "id": "57e5b3e5-86bb-4516-9cd6-bee512186cf3"
                    },
                    {
                        "group": "right",
                        "id": "37464204-d760-4961-8769-62e81d7b8abb"
                    },
                    {
                        "group": "bottom",
                        "id": "48f248aa-e79b-4c3e-97ca-b9f72ba20ac8"
                    },
                    {
                        "group": "left",
                        "id": "b9418203-5036-4d51-a79c-d50e67278aba"
                    }
                ]
            },
            "id": "a3de8273-8160-459d-8b41-5b4efb757638",
            "zIndex": 13
        },
        {
            "position": {
                "x": 219.99999999999994,
                "y": 500.0000000000002
            },
            "size": {
                "width": 540,
                "height": 180
            },
            "attrs": {
                "text": {
                    "text": "",
                    "text_hint": "String"
                },
                "regex": {
                    "type": "Group"
                },
                "title": {
                    "text": "Group",
                    "text_hint": "                          A regex group like:                              (abc)                          usage:                              group = Group('abc')                              pattern = Pattern(group, X(), group)                              print(pattern.mkregex())                          Output:                              (abc).\\1                          Notice that the first reference to the group it serializes                          to the regex group construct but the second one serializes to                           the group reference.                          "
                }
            },
            "shape": "flow-chart-title-rect",
            "ports": {
                "groups": {
                    "top": {
                        "position": "top",
                        "attrs": {
                            "circle": {
                                "r": 3,
                                "magnet": true,
                                "stroke": "#5F95FF",
                                "strokeWidth": 1,
                                "fill": "#fff",
                                "style": {
                                    "visibility": "hidden"
                                }
                            }
                        }
                    },
                    "right": {
                        "position": "right",
                        "attrs": {
                            "circle": {
                                "r": 3,
                                "magnet": true,
                                "stroke": "#5F95FF",
                                "strokeWidth": 1,
                                "fill": "#fff",
                                "style": {
                                    "visibility": "hidden"
                                }
                            }
                        }
                    },
                    "bottom": {
                        "position": "bottom",
                        "attrs": {
                            "circle": {
                                "r": 3,
                                "magnet": true,
                                "stroke": "#5F95FF",
                                "strokeWidth": 1,
                                "fill": "#fff",
                                "style": {
                                    "visibility": "hidden"
                                }
                            }
                        }
                    },
                    "left": {
                        "position": "left",
                        "attrs": {
                            "circle": {
                                "r": 3,
                                "magnet": true,
                                "stroke": "#5F95FF",
                                "strokeWidth": 1,
                                "fill": "#fff",
                                "style": {
                                    "visibility": "hidden"
                                }
                            }
                        }
                    }
                },
                "items": [
                    {
                        "group": "top",
                        "id": "167240df-8bdd-4094-86ff-4abbe1c8e6da"
                    },
                    {
                        "group": "right",
                        "id": "5b097bde-c0bf-4f8c-a966-134527fa9797"
                    },
                    {
                        "group": "bottom",
                        "id": "61a9351b-d8a0-4a13-9f15-3ba39d1e9ee4"
                    },
                    {
                        "group": "left",
                        "id": "632cf215-75bf-4a7c-a642-2676a5ea2949"
                    }
                ]
            },
            "id": "57569ae3-004c-4e99-b768-3d65563478f6",
            "data": {
                "parent": true
            },
            "zIndex": 14,
            "children": [
                "9393d9a5-b3a2-4a3a-a413-00cb5c6e6907",
                "9181dce5-9035-42b0-893b-d667d02b63bf",
                "ca14ebe1-fd5e-4a35-af98-880e55464199",
                "e5df77c8-cdbe-42be-8a9d-cd3aae61e9c4",
                "127be80a-3413-48d1-9039-6de11fef0934"
            ]
        },
        {
            "position": {
                "x": 254,
                "y": 556
            },
            "size": {
                "width": 100,
                "height": 68
            },
            "attrs": {
                "text": {
                    "text": "www",
                    "text_hint": "Type String"
                },
                "body": {
                    "stroke": "#73d13d"
                },
                "regex": {
                    "type": "String"
                },
                "title": {
                    "text": "String",
                    "text_hint": "the String"
                }
            },
            "shape": "flow-chart-title-rect",
            "ports": {
                "groups": {
                    "top": {
                        "position": "top",
                        "attrs": {
                            "circle": {
                                "r": 3,
                                "magnet": true,
                                "stroke": "#5F95FF",
                                "strokeWidth": 1,
                                "fill": "#fff",
                                "style": {
                                    "visibility": "hidden"
                                }
                            }
                        }
                    },
                    "right": {
                        "position": "right",
                        "attrs": {
                            "circle": {
                                "r": 3,
                                "magnet": true,
                                "stroke": "#5F95FF",
                                "strokeWidth": 1,
                                "fill": "#fff",
                                "style": {
                                    "visibility": "hidden"
                                }
                            }
                        }
                    },
                    "bottom": {
                        "position": "bottom",
                        "attrs": {
                            "circle": {
                                "r": 3,
                                "magnet": true,
                                "stroke": "#5F95FF",
                                "strokeWidth": 1,
                                "fill": "#fff",
                                "style": {
                                    "visibility": "hidden"
                                }
                            }
                        }
                    },
                    "left": {
                        "position": "left",
                        "attrs": {
                            "circle": {
                                "r": 3,
                                "magnet": true,
                                "stroke": "#5F95FF",
                                "strokeWidth": 1,
                                "fill": "#fff",
                                "style": {
                                    "visibility": "hidden"
                                }
                            }
                        }
                    }
                },
                "items": [
                    {
                        "group": "top",
                        "id": "4a87c3cf-0bf0-4ac3-899b-a83024b70828"
                    },
                    {
                        "group": "right",
                        "id": "aa1648a5-b232-4613-8817-ce0fba0c54ab"
                    },
                    {
                        "group": "bottom",
                        "id": "13ce0317-1c40-4755-841c-09fad8094445"
                    },
                    {
                        "group": "left",
                        "id": "8342506f-3e92-4b1a-8627-c459558d922a"
                    }
                ]
            },
            "id": "9393d9a5-b3a2-4a3a-a413-00cb5c6e6907",
            "zIndex": 15,
            "parent": "57569ae3-004c-4e99-b768-3d65563478f6"
        },
        {
            "position": {
                "x": 421,
                "y": 556
            },
            "size": {
                "width": 100,
                "height": 68
            },
            "attrs": {
                "text": {
                    "text": "olllo",
                    "text_hint": "Type String"
                },
                "body": {
                    "stroke": "#73d13d"
                },
                "regex": {
                    "type": "String"
                },
                "title": {
                    "text": "String",
                    "text_hint": "the String"
                }
            },
            "shape": "flow-chart-title-rect",
            "ports": {
                "groups": {
                    "top": {
                        "position": "top",
                        "attrs": {
                            "circle": {
                                "r": 3,
                                "magnet": true,
                                "stroke": "#5F95FF",
                                "strokeWidth": 1,
                                "fill": "#fff",
                                "style": {
                                    "visibility": "hidden"
                                }
                            }
                        }
                    },
                    "right": {
                        "position": "right",
                        "attrs": {
                            "circle": {
                                "r": 3,
                                "magnet": true,
                                "stroke": "#5F95FF",
                                "strokeWidth": 1,
                                "fill": "#fff",
                                "style": {
                                    "visibility": "hidden"
                                }
                            }
                        }
                    },
                    "bottom": {
                        "position": "bottom",
                        "attrs": {
                            "circle": {
                                "r": 3,
                                "magnet": true,
                                "stroke": "#5F95FF",
                                "strokeWidth": 1,
                                "fill": "#fff",
                                "style": {
                                    "visibility": "hidden"
                                }
                            }
                        }
                    },
                    "left": {
                        "position": "left",
                        "attrs": {
                            "circle": {
                                "r": 3,
                                "magnet": true,
                                "stroke": "#5F95FF",
                                "strokeWidth": 1,
                                "fill": "#fff",
                                "style": {
                                    "visibility": "hidden"
                                }
                            }
                        }
                    }
                },
                "items": [
                    {
                        "group": "top",
                        "id": "4a87c3cf-0bf0-4ac3-899b-a83024b70828"
                    },
                    {
                        "group": "right",
                        "id": "aa1648a5-b232-4613-8817-ce0fba0c54ab"
                    },
                    {
                        "group": "bottom",
                        "id": "13ce0317-1c40-4755-841c-09fad8094445"
                    },
                    {
                        "group": "left",
                        "id": "8342506f-3e92-4b1a-8627-c459558d922a"
                    }
                ]
            },
            "id": "9181dce5-9035-42b0-893b-d667d02b63bf",
            "zIndex": 16,
            "parent": "57569ae3-004c-4e99-b768-3d65563478f6"
        },
        {
            "position": {
                "x": 609,
                "y": 556
            },
            "size": {
                "width": 100,
                "height": 68
            },
            "attrs": {
                "text": {
                    "text": "top",
                    "text_hint": "Type String"
                },
                "body": {
                    "stroke": "#73d13d"
                },
                "regex": {
                    "type": "String"
                },
                "title": {
                    "text": "String",
                    "text_hint": "the String"
                }
            },
            "shape": "flow-chart-title-rect",
            "ports": {
                "groups": {
                    "top": {
                        "position": "top",
                        "attrs": {
                            "circle": {
                                "r": 3,
                                "magnet": true,
                                "stroke": "#5F95FF",
                                "strokeWidth": 1,
                                "fill": "#fff",
                                "style": {
                                    "visibility": "hidden"
                                }
                            }
                        }
                    },
                    "right": {
                        "position": "right",
                        "attrs": {
                            "circle": {
                                "r": 3,
                                "magnet": true,
                                "stroke": "#5F95FF",
                                "strokeWidth": 1,
                                "fill": "#fff",
                                "style": {
                                    "visibility": "hidden"
                                }
                            }
                        }
                    },
                    "bottom": {
                        "position": "bottom",
                        "attrs": {
                            "circle": {
                                "r": 3,
                                "magnet": true,
                                "stroke": "#5F95FF",
                                "strokeWidth": 1,
                                "fill": "#fff",
                                "style": {
                                    "visibility": "hidden"
                                }
                            }
                        }
                    },
                    "left": {
                        "position": "left",
                        "attrs": {
                            "circle": {
                                "r": 3,
                                "magnet": true,
                                "stroke": "#5F95FF",
                                "strokeWidth": 1,
                                "fill": "#fff",
                                "style": {
                                    "visibility": "hidden"
                                }
                            }
                        }
                    }
                },
                "items": [
                    {
                        "group": "top",
                        "id": "4a87c3cf-0bf0-4ac3-899b-a83024b70828"
                    },
                    {
                        "group": "right",
                        "id": "aa1648a5-b232-4613-8817-ce0fba0c54ab"
                    },
                    {
                        "group": "bottom",
                        "id": "13ce0317-1c40-4755-841c-09fad8094445"
                    },
                    {
                        "group": "left",
                        "id": "8342506f-3e92-4b1a-8627-c459558d922a"
                    }
                ]
            },
            "id": "ca14ebe1-fd5e-4a35-af98-880e55464199",
            "zIndex": 17,
            "parent": "57569ae3-004c-4e99-b768-3d65563478f6"
        },
        {
            "shape": "edge",
            "attrs": {
                "line": {
                    "stroke": "#5F95FF",
                    "strokeWidth": 1,
                    "targetMarker": {
                        "name": "classic",
                        "size": 8,
                        "width": 8,
                        "height": 8
                    }
                },
                "regex": {
                    "type": "join"
                }
            },
            "id": "e5df77c8-cdbe-42be-8a9d-cd3aae61e9c4",
            "router": {
                "name": "manhattan"
            },
            "zIndex": 18,
            "source": {
                "cell": "9393d9a5-b3a2-4a3a-a413-00cb5c6e6907",
                "port": "aa1648a5-b232-4613-8817-ce0fba0c54ab"
            },
            "target": {
                "cell": "9181dce5-9035-42b0-893b-d667d02b63bf",
                "port": "8342506f-3e92-4b1a-8627-c459558d922a"
            },
            "parent": "57569ae3-004c-4e99-b768-3d65563478f6"
        },
        {
            "shape": "edge",
            "attrs": {
                "line": {
                    "stroke": "#5F95FF",
                    "strokeWidth": 1,
                    "targetMarker": {
                        "name": "classic",
                        "size": 8,
                        "width": 8,
                        "height": 8
                    }
                },
                "regex": {
                    "type": "join"
                }
            },
            "id": "127be80a-3413-48d1-9039-6de11fef0934",
            "router": {
                "name": "manhattan"
            },
            "zIndex": 19,
            "source": {
                "cell": "9181dce5-9035-42b0-893b-d667d02b63bf",
                "port": "aa1648a5-b232-4613-8817-ce0fba0c54ab"
            },
            "target": {
                "cell": "ca14ebe1-fd5e-4a35-af98-880e55464199",
                "port": "8342506f-3e92-4b1a-8627-c459558d922a"
            },
            "parent": "57569ae3-004c-4e99-b768-3d65563478f6"
        }
    ]
}
export default graphData_en
